// Copyright 2025-2026 Florian Gallon. All Rights reserved.
import { Check, Minus } from 'lucide-react';

export default function Comparison({ isFr }) {
  const them = isFr
    ? [
        'Outils CRM reconditionnés avec un thème boulangerie',
        'Calculs de recettes à faire à la main',
        'Aucune traçabilité des ingrédients',
      ]
    : [
        'Repackaged CRM tools with a bakery theme',
        'Recipe maths still done by hand',
        'No ingredient traceability',
      ];

  const ours = isFr
    ? [
        'Conçu pour les opérations de boulangerie artisanale',
        'Calcul automatique des recettes à partir des commandes',
        'Suivi complet des lots et traçabilité',
        '20 $/mois, tout inclus',
      ]
    : [
        'Built for artisan bakery operations',
        'Automatic recipe scaling from your orders',
        'Complete batch tracking and traceability',
        '$20/month, everything included',
      ];

  return (
    <section className="dbk-section dbk-section--alt">
      <div className="dbk-wrap">
        <div className="dbk-head">
          <h2 className="dbk-h2">
            {isFr ? 'Pourquoi les boulangers choisissent Digi-Bakery' : 'Why bakers choose Digi-Bakery'}
          </h2>
        </div>

        <div className="dbk-compare">
          <div className="dbk-compare__col dbk-compare__col--them">
            <p className="dbk-compare__label">
              {isFr ? 'Logiciels de boulangerie classiques' : 'Typical bakery software'}
            </p>
            <ul className="dbk-compare__list">
              {them.map((t) => (
                <li key={t}><Minus size={16} strokeWidth={2} />{t}</li>
              ))}
            </ul>
          </div>

          <div className="dbk-compare__col dbk-compare__col--ours">
            <p className="dbk-compare__label">Digi-Bakery</p>
            <ul className="dbk-compare__list">
              {ours.map((t) => (
                <li key={t}><Check size={16} strokeWidth={2.25} />{t}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
